import { useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { bindActionCreators } from 'redux';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { clearCart } from '../../cart/action';
import { formatNumber } from '../../../util/utility';
import { firstQueryValue } from '../../../util/queryParams';

type SuccessProps = {
    transactionId: unknown;
    retailPrice: unknown;
    isShare: boolean;
    clearCart: () => void;
};

function Success({ clearCart: clearCartAction, isShare }: SuccessProps) {
    const { search } = useLocation();

    const { payAmount, shippingCharge } = useMemo(() => {
        const parsed = queryString.parse(search);
        return {
            payAmount: parsed.payAmt ? firstQueryValue(parsed.payAmt) : undefined,
            shippingCharge: parsed.shipAmt ? firstQueryValue(parsed.shipAmt) : '0',
        };
    }, [search]);

    useEffect(() => {
        clearCartAction();
    }, [clearCartAction]);

    const redirectScreen = useCallback(() => {
        window.open('https://www.societynotebook.com/', '_self');
    }, []);

    const redirectToCloseScreen = useCallback(() => {
        const w = window as any;
        if (w.ReactNativeWebView && typeof w.ReactNativeWebView.postMessage === 'function') {
            try {
                w.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: 'CLOSE_WEBVIEW', source: 'payment_success_ok' })
                );
            } catch (_error) {
                w.ReactNativeWebView.postMessage('CLOSE_WEBVIEW');
            }
            return;
        }
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        window.close();
    }, []);

    const shippingNum = shippingCharge ? parseInt(String(shippingCharge), 10) : 0;
    const payNum = payAmount ? parseInt(String(payAmount), 10) : 0;
    const amount = payNum + shippingNum;

    return (
        <div className="Card-container" style={{ background: 'white' }}>
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 no-Pd">
                    <div className="card">
                        <div className="card-body cart-card">
                            <div className="cart-header">
                                <div className="flex-row" style={{ justifyContent: 'center' }}>
                                    <div className="card-text F1">Success</div>
                                    <div className="card-text F1"></div>
                                </div>

                                <div className="flex-row" style={{ justifyContent: 'center' }}>
                                    <div className="card-text F3">Thank You, We received your Payment...</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row Mb-3 Mb-B10 card paySuccess-card card-shadow-NA">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="" style={{ padding: '3em 0px' }}>
                        <div className="card-body no-Pd" style={{ textAlign: 'center' }}>
                            <svg className="" width="100" height="100" viewBox="0 0 100 100">
                                <circle className="checkmark-disc" cx="50" cy="50" r="48" stroke="#4CAF50" strokeWidth="1" fill="#eef4f7">
                                    {' '}
                                </circle>
                                <path
                                    className="checkmark-check"
                                    d="M75 33L40 66 25 50"
                                    fill="none"
                                    stroke="#4CAF50"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                ></path>
                            </svg>

                            <div className="card-body card-Pd alignCen">
                                <h1 className="card-title payTxt">Payment Successful</h1>
                            </div>

                            <div className="card-body card-Pd alignCen">
                                <div className="card-text Fw F2">Your payment of {formatNumber(amount)} has been done</div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer>
                    {isShare ? (
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{ padding: '0px' }}>
                            <a type="submit" className="BuyBtnFooter grn-btn" onClick={redirectScreen}>
                                <div className="align-text-ok" style={{ left: '43%' }}>
                                    Know More{' '}
                                </div>
                            </a>
                        </div>
                    ) : (
                        <div className="col-sm-12 col-md-12 col-lg-12" style={{ padding: '0px' }}>
                            <a type="submit" className="BuyBtnFooter grn-btn" onClick={redirectToCloseScreen}>
                                <div className="align-text-ok">OK</div>
                            </a>
                        </div>
                    )}
                </footer>
            </div>
        </div>
    );
}

const mapStateToProps = (state: { pay: { transactionId: unknown; retailPrice: unknown; isShare: boolean } }) => ({
    transactionId: state.pay.transactionId,
    retailPrice: state.pay.retailPrice,
    isShare: state.pay.isShare,
});

const mapDispatchToProps = (dispatch: unknown) =>
    bindActionCreators(
        {
            clearCart,
        },
        dispatch as never
    );

export default compose(connect(mapStateToProps, mapDispatchToProps))(Success);
